<template>
  <material-card
    :title="`${ $t('Line alarms') }`"
    color="dover-blue">
    <v-form
      ref="form"
      v-model="isValidationOk"
      lazy-validation>
      <v-container
        py-0
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          wrap>
          <v-flex
            xs12
            md3>
            <MaglinkComponentLldList
              :loading="progessBar.loading"
              :filters="filters"
              :llds="llds" />
          </v-flex>
          <v-flex
            xs12
            md2>
            <v-switch
              v-model="filters.all"
              :disabled="progessBar.loading"
              :label="filters.type === 4 ? `${ $t('All Lines') }` : `${ '' }`"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md2>
            <MaglinkComponentDatePicker
              :component-key="1"
              :rules-is-date="rules.isDate"
              :initial-date="dateFromToday(-7)"
              :date-label="getDateLabel('From')"
              :date-format="systemSettings.dateFormat"
              :loading="progessBar.loading"
              :clear-date="true"
              @getDate="onGetDate"
              @checkDates="onCheckDates"/>
          </v-flex>
          <v-flex
            xs12
            md2>
            <MaglinkComponentDatePicker
              :component-key="2"
              :rules-is-date="rules.isDate"
              :initial-date="dateFromToday(0)"
              :date-label="getDateLabel('To')"
              :date-format="systemSettings.dateFormat"
              :loading="progessBar.loading"
              :clear-date="true"
              @getDate="onGetDate"
              @checkDates="onCheckDates"/>
          </v-flex>
          <v-flex
            xs12
            md3
            text-xs-right>
            <v-btn
              :disabled="!isValidationOk || progessBar.loading"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="applyFilter">
              {{ $t('Load') }}
            </v-btn>
          </v-flex>
          <v-flex
            xs12
            md12
            lg12>
            <MaglinkComponentLoadingBar
              :loading="progessBar.loading"
              :indeterminate="false"
              :max-value="progessBar.maxValue"
              :value="progessBar.currentValue" />
            <span>{{ itemCountLabel }}</span>
            <hr>
          </v-flex>
          <v-flex
            xs12
            md12>
            <v-data-table
              :headers="headers"
              :items="dataSource"
              :no-data-text="`${ Maglink.NoDataMessage(false) }`"
              :no-results-text="`${ Maglink.NoDataMessage(true) }`"
              hide-actions>
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="dover-light-blue-color"
                  v-text="header.text" />
              </template>
              <template
                slot="items"
                slot-scope="{ index, item }">
                <tr
                  :style="{backgroundColor: ((index % 2 === 0) ? '#cfdbfb' : 'transparent' ) }"
                  class="text-xs-left">
                  <td class="text-xs-center">{{ Maglink.GetCustomDateTime(item.measuredOn, systemSettings.dateFormat) }}</td>
                  <td class="text-xs-right">{{ item.lldNumber }}</td>
                  <td class="text-xs-left">{{ Maglink.GetStatusInfo(item.lldStatus).statusDesc }}</td>
                  <td class="text-xs-center">{{ Maglink.GetAckDescription(item.ackStatus) }}</td>
                  <td>
                    <img
                      :src="Maglink.GetImageAlarm(item.ackStatus)"
                      width="15px">
                  </td>
                  <td class="text-xs-right">{{ Maglink.LeakageFormat(Maglink.LeakageToDisplay(item.userLeakRateThreshold, systemSettings.volumeUnit)) }}</td>
                  <td class="text-xs-right">{{ Maglink.PressureFormat(item.runningPressure) }}</td>
                  <td class="text-xs-right">{{ Maglink.PressureFormat(item.referencePressure) }}</td>
                  <td class="text-xs-right">{{ Maglink.LeakageFormat(Maglink.LeakageToDisplay(item.leakRate, systemSettings.volumeUnit)) }}</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </material-card>
</template>

<script>

export default {
  props: {
    llds: {
      type: Array,
      required: true,
      default: () => []
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => {}
    },
    options: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    isValidationOk: false,
    rules: {
      isDate: [ v => true ]
    },
    progessBar: {
      loading: false,
      maxValue: 100,
      currentValue: 0
    },
    itemCountLabel: '',
    headers: [],
    dataSource: [],
    filters: {
      all: false,
      number: 1,
      type: 4,
      fromDay: '',
      toDay: ''
    },
    volUdm: ''
  }),
  mounted () {
    var currentDate = new Date()
    this.filters.toDay = currentDate.toISOString().substr(0, 10)

    currentDate.setDate(currentDate.getDate() - 7)
    this.filters.fromDay = currentDate.toISOString().substr(0, 10)

    this.volUdm = this.options.volumeUnits[this.systemSettings.volumeUnit || 0].desc

    this.headers = [
      { sortable: false, text: this.$t('Time'), align: 'center' },
      { sortable: false, text: this.$t('Line'), align: 'right' },
      { sortable: false, text: this.$t('Alarm'), align: 'left' },
      { sortable: false, text: this.$t('Status'), align: 'center' },
      { sortable: false, text: '' },
      { sortable: false, text: this.$t('Test type') + ' (' + this.volUdm + '/' + this.$t('H').toLowerCase() + ')', align: 'right' },
      { sortable: false, text: this.$t('Running pressure (psi)'), align: 'right' },
      { sortable: false, text: this.$t('Ref. pressure (psi)'), align: 'right' },
      { sortable: false, text: this.$t('Rate') + ' (' + this.volUdm + '/' + this.$t('H').toLowerCase() + ')', align: 'right' }
    ]

    this.applyFilter()
  },
  methods: {
    applyFilter () {
      if (!this.onCheckDates()) return
      this.getDataSource()
    },
    dateFromToday (days) {
      var currentDate = new Date()
      currentDate.setDate(currentDate.getDate() + days)

      return currentDate
    },
    getDataSource () {
      this.progessBar.loading = true
      this.dataSource = []

      this.Maglink.GetReportLldAlarms(this.filters)
        .then(response => {
          this.progessBar.maxValue = response.data.length

          for (var i = 0; i < response.data.length; i++) {
            this.progessBar.currentValue = i
            this.dataSource.push(this.Maglink.ToDisplay(response.data[i], this.systemSettings.levelUnit, this.systemSettings.volumeUnit))
          }
          this.progessBar.loading = false
          this.itemCountLabel = this.$t('Items: {0}', [ this.dataSource.length ])
        })
        .catch(error => {
          this.progessBar.loading = false
          this.snack('error', error.message)
        })
    },
    getDateLabel (value) {
      return this.$t(value) + ' (' + this.systemSettings.dateFormat + ')'
    },
    onCheckDates () {
      // no check if one date is missing
      if (this.filters.fromDay === undefined) return true
      if (this.filters.toDay === undefined) return true

      if (this.filters.fromDay > this.filters.toDay) {
        this.isValidationOk = false
        this.rules.isDate = [this.$t('Wrong date value')]
      } else {
        this.rules.isDate = [ v => true ]
        this.isValidationOk = true
        this.$refs.form.resetValidation()
      }

      return this.isValidationOk
    },
    onGetDate (componentKey, day) {
      if (componentKey === 1) {
        this.filters.fromDay = day
      } else {
        this.filters.toDay = day
      }

      this.onCheckDates()
    },
    snack (color, message) {
      message = this.$t('Line alarms') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>

<style scoped>
.scroller {
  table-layout: fixed;
  height: 300px;
  max-height: 300px;
  overflow: auto;
}
.list {
    background-color: #ffffff;
    -webkit-overflow-scrolling: touch;
}
.column {
  width: 20%;
  display: inline-block;
  text-align: center;
  font-weight: bold;
  color: gray;
}
.columnbig {
  width: 30%;
  display: inline-block;
  text-align: center;
  font-weight: bold;
  color: gray;
}
</style>
